import { render, staticRenderFns } from "./ShowofforumHome.vue?vue&type=template&id=afd12f18&scoped=true&"
import script from "./ShowofforumHome.vue?vue&type=script&lang=js&"
export * from "./ShowofforumHome.vue?vue&type=script&lang=js&"
import style0 from "./ShowofforumHome.vue?vue&type=style&index=0&id=afd12f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd12f18",
  null
  
)

export default component.exports